/**
 *  based on https://github.com/ngneat/until-destroy
 */
import {
  InjectableType,
  ɵComponentType as ComponentType,
  ɵComponentType,
  ɵDirectiveType as DirectiveType,
  ɵDirectiveType,
} from '@angular/core';

import { Type, ɵNG_PIPE_DEF, ɵPipeDef } from '@angular/core';
import { SubSink } from 'subsink';

export const DECORATOR_APPLIED: unique symbol = Symbol('__decoratorApplied');
const NG_PIPE_DEF = ɵNG_PIPE_DEF as 'ɵpipe';

export function AutoUnsubscribe(): ClassDecorator {
  return (type: any) => {
    if (isPipe(type)) {
      decoratePipe(type);
    } else {
      decorateProviderDirectiveOrComponent(type);
    }

    markAsDecorated(type);
  };
}

function unsubscribe(property: unknown): void {
  if (property instanceof SubSink) property.unsubscribe();
}

// Angular doesn't expose publicly `PipeType` but it actually has it.
export interface PipeType<T> extends Type<T> {
  ɵpipe: ɵPipeDef<T>;
}

export function isPipe<T>(target: any): target is PipeType<T> {
  return !!target[NG_PIPE_DEF];
}

export function markAsDecorated<T>(
  type: InjectableType<T> | PipeType<T> | ɵDirectiveType<T> | ɵComponentType<T>
): void {
  // Store this property on the prototype if it's an injectable class, component or directive.
  // We will be able to handle class extension this way.
  type.prototype[DECORATOR_APPLIED] = true;
}

function decorateNgOnDestroy(ngOnDestroy: (() => void) | null | undefined) {
  return function (this: any) {
    // Invoke the original `ngOnDestroy` if it exists
    ngOnDestroy && ngOnDestroy.call(this);

    for (const property in this) {
      unsubscribe(this[property]);
    }
  };
}

function decorateProviderDirectiveOrComponent<T>(
  type: InjectableType<T> | DirectiveType<T> | ComponentType<T>
): void {
  type.prototype.ngOnDestroy = decorateNgOnDestroy(type.prototype.ngOnDestroy);
}

function decoratePipe<T>(type: PipeType<T>): void {
  const def = type.ɵpipe;
  def.onDestroy = decorateNgOnDestroy(def.onDestroy);
}
